import axios, { AxiosError } from 'axios';
import { Api } from '../../axiosApi';

interface ItemVenda {
  qtds: number;
  idmov: string;
  descricao: string;
  referencia: string;
  un: string;
  preco: number;
  total: number;
}

interface RomaneioVenda {
  idmov: string;
  emissao: string;
  numero: string | null;
  idparceiro: string;
  idoperacao: string;
  nome: string;
  cpf: string;
  descricao: string;
  tpag: string;
  vprod: number;
  desconto: number;
  acrescimo: number;
  total: number;
}
interface ProdutoEstoque {
  ean: string;
  descricao: string;
  localizado: string;
  preco: number;
  un: string;
  referencia: string | null;
  pvenda: number;
  marca: string;
  idgrupo: string;
  quan: number;
  totalcompra: number;
  total: number;
}

export interface Venda {
  romaneios: RomaneioVenda;
  itens: ItemVenda[];
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}

const RVendas = async (
  parceiro: string,
  detalhada: string,
  operacao: string,
  datainicial: string,
  datafinal: string
): Promise<Venda[] | Error> => {

  try {

    const urlRelativa =
      `/rvendas?parceiro=${parceiro}&detalhes=${detalhada}&operacao=${operacao}&datainicial=${datainicial}&datafinal=${datafinal}`;

    const { data } = await Api.get<Venda[]>(urlRelativa);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};



const Restoque = async (
  grupo: string,
  subgrupo: string,
  tipo: string
): Promise<ProdutoEstoque[] | Error> => {

  try {

    const urlRelativa =
      `/rprodutos?grupo=${grupo}&subgrupo=${subgrupo}&tipo=${tipo}`;

    const { data } = await Api.get<ProdutoEstoque[]>(urlRelativa);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};

export const RelatorioEstoqueService = {
  RVendas,
  Restoque
};